// generated by the plop

export class PingTerminal {
  static type = '[receipt] PingTerminal';
}
